import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// BANK DEPOSIT VERIFICATION
// Legacy: /AccountsApproval/VerifyBankDeposit (+ Grid / VerifyBankDepositView / UpdateBankDepositView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — CC cash deposits (TypeOfTransactionId 9) pending at this role's level.
export const getVerificationDeposits = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetDeposit`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one pending deposit (a one-row list; carries MOID).
export const getVerificationDepositById = async (bankTranId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationdepositbyId`, { params: { BankTranid: bankTranId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of a returned deposit for the resubmit form (includes the cost center's available cash, CCAmount).
export const getReturnedDepositById = async (bankTranId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetReturndepositbyId`, { params: { BankTranid: bankTranId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Bank dropdown for the resubmit form.
export const getBanksForDeposit = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetBankDetailsfordeposit`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spVerifyDeposit — success literal "Submitted").
export const verifyDeposit = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Verifydeposit`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Resubmit a returned deposit (spUpdateDeposit — success literal "Successfull").
export const updateDeposit = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Updatedeposit`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
